import React from 'react';
import { Calendar, Tag, Mail, Clock, MessageSquare } from 'lucide-react';
import { motion } from 'framer-motion';
export function InboxMockup() {
  return <div className="relative w-full bg-[#fffefc] rounded-xl shadow-2xl border border-[#E8DFD8] overflow-hidden" data-id="element-85">
      {/* Email Inbox */}
      <div className="bg-[#fffefc] border-b border-[#E8DFD8] p-2.5" data-id="element-86">
        <div className="flex items-center justify-between" data-id="element-87">
          <h3 className="font-semibold text-[#2D1810] text-sm" data-id="element-88">Inbox</h3>
          <span className="text-xs text-[#6B5244]" data-id="element-89">3 messages</span>
        </div>
      </div>
      <div className="divide-y divide-[#E8DFD8]" data-id="element-90">
        {/* Email 1 - School Trip */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2
      }} className="p-2.5 hover:bg-[#F5F0ED] cursor-pointer relative bg-[#fffefc]" data-id="element-91">
          <div className="flex items-start gap-2" data-id="element-92">
            <div className="w-7 h-7 bg-[#7B9FAB] rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0 text-xs" data-id="element-93">
              S
            </div>
            <div className="flex-1 min-w-0" data-id="element-94">
              <p className="font-medium text-[#2D1810] text-xs" data-id="element-95">
                School Trip to London Zoo
              </p>
              <p className="text-[#6B5244] text-[10px] mt-0.5" data-id="element-96">
                admin@school.com
              </p>
            </div>
          </div>
          {/* Processing indicator */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.5
        }} className="absolute top-1.5 right-1.5" data-id="element-97">
            <div className="bg-[#553116] text-white text-[10px] px-1.5 py-0.5 rounded-full flex items-center gap-1 shadow-md" data-id="element-98">
              <Calendar size={10} data-id="element-99" />
              <span data-id="element-100">Creating reminders...</span>
            </div>
          </motion.div>
        </motion.div>
        {/* Email 2 - Anthropic */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.3
      }} className="p-2.5 hover:bg-[#F5F0ED] cursor-pointer" data-id="element-101">
          <div className="flex items-start gap-2" data-id="element-102">
            <div className="w-7 h-7 bg-[#9B7EBD] rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0 text-xs" data-id="element-103">
              A
            </div>
            <div className="flex-1 min-w-0" data-id="element-104">
              <p className="font-medium text-[#2D1810] text-xs" data-id="element-105">
                Investment Deck
              </p>
              <p className="text-[#6B5244] text-[10px] mt-0.5" data-id="element-106">
                team@anthropic.com
              </p>
              <div className="mt-1" data-id="element-107">
                <span className="inline-flex items-center gap-0.5 bg-[#F5F0ED] text-[#553116] text-[10px] px-1.5 py-0.5 rounded-full font-medium border border-[#E8DFD8]" data-id="element-108">
                  <Tag size={10} data-id="element-109" />
                  VIP Founder
                </span>
              </div>
            </div>
          </div>
        </motion.div>
        {/* Email 3 - Aviva */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4
      }} className="p-2.5 hover:bg-[#F5F0ED] cursor-pointer" data-id="element-110">
          <div className="flex items-start gap-2" data-id="element-111">
            <div className="w-7 h-7 bg-[#7FA87F] rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0 text-xs" data-id="element-112">
              A
            </div>
            <div className="flex-1 min-w-0" data-id="element-113">
              <p className="font-medium text-[#2D1810] text-xs" data-id="element-114">
                Car Insurance Renewal
              </p>
              <p className="text-[#6B5244] text-[10px] mt-0.5" data-id="element-115">
                renewal@aviva.com
              </p>
            </div>
          </div>
        </motion.div>
      </div>
      {/* WhatsApp Reminder Popup */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      delay: 1.5
    }} className="absolute bottom-2.5 right-[13rem] bg-[#fffefc] rounded-lg shadow-2xl border border-[#E8DFD8] p-2.5 w-52" data-id="element-116">
        <div className="flex items-center gap-1.5 mb-2" data-id="element-117">
          <div className="w-6 h-6 bg-[#E8F5E9] rounded-lg flex items-center justify-center" data-id="element-118">
            <MessageSquare size={14} className="text-[#4CAF50]" data-id="element-119" />
          </div>
          <h4 className="font-semibold text-[#2D1810] text-xs" data-id="element-120">
            WhatsApp Reminder Set
          </h4>
        </div>
        <div className="space-y-1.5 text-xs" data-id="element-121">
          <div className="flex items-start gap-1.5" data-id="element-122">
            <Calendar size={12} className="text-[#6B5244] mt-0.5 flex-shrink-0" data-id="element-123" />
            <p className="text-[#6B5244] text-[11px]" data-id="element-124">May 25th, 2024</p>
          </div>
          <div className="flex items-start gap-1.5" data-id="element-125">
            <Mail size={12} className="text-[#6B5244] mt-0.5 flex-shrink-0" data-id="element-126" />
            <div data-id="element-127">
              <p className="text-[#2D1810] font-medium text-[11px]" data-id="element-128">
                Buy food for Harry's packed lunch for the Zoo in weekly food
                shop
              </p>
            </div>
          </div>
        </div>
        <motion.div initial={{
        width: 0
      }} animate={{
        width: '100%'
      }} transition={{
        delay: 1.9,
        duration: 0.5
      }} className="mt-2 h-0.5 bg-[#4CAF50] rounded-full" data-id="element-129" />
      </motion.div>
      {/* Calendar Event Creation Popup */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      delay: 0.8
    }} className="absolute bottom-2.5 right-2.5 bg-[#fffefc] rounded-lg shadow-2xl border border-[#E8DFD8] p-2.5 w-48" data-id="element-130">
        <div className="flex items-center gap-1.5 mb-2" data-id="element-131">
          <div className="w-6 h-6 bg-[#F5F0ED] rounded-lg flex items-center justify-center" data-id="element-132">
            <Calendar size={14} className="text-[#553116]" data-id="element-133" />
          </div>
          <h4 className="font-semibold text-[#2D1810] text-xs" data-id="element-134">
            Calendar Event Created
          </h4>
        </div>
        <div className="space-y-1.5 text-xs" data-id="element-135">
          <div className="flex items-start gap-1.5" data-id="element-136">
            <Mail size={12} className="text-[#6B5244] mt-0.5 flex-shrink-0" data-id="element-137" />
            <div data-id="element-138">
              <p className="font-medium text-[#2D1810] text-[11px]" data-id="element-139">
                Harry's School Trip to the Zoo
              </p>
            </div>
          </div>
          <div className="flex items-start gap-1.5" data-id="element-140">
            <Calendar size={12} className="text-[#6B5244] mt-0.5 flex-shrink-0" data-id="element-141" />
            <p className="text-[#6B5244] text-[11px]" data-id="element-142">June 1st, 2024</p>
          </div>
          <div className="flex items-start gap-1.5" data-id="element-143">
            <Clock size={12} className="text-[#6B5244] mt-0.5 flex-shrink-0" data-id="element-144" />
            <div data-id="element-145">
              <p className="text-[#6B5244] text-[11px]" data-id="element-146">Reminder:</p>
              <p className="text-[#2D1810] font-medium text-[11px]" data-id="element-147">
                Packed lunch
              </p>
            </div>
          </div>
        </div>
        <motion.div initial={{
        width: 0
      }} animate={{
        width: '100%'
      }} transition={{
        delay: 1.2,
        duration: 0.5
      }} className="mt-2 h-0.5 bg-[#553116] rounded-full" data-id="element-148" />
      </motion.div>
    </div>;
}